import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  '@global': {
    '@keyframes helpCenterPulse': {
      '0%, 70%, 100%': { opacity: 0, transform: 'scale(0.9)' },
      '80%':           { opacity: 0.6, transform: 'scale(1)' },
      '90%':           { opacity: 0.3, transform: 'scale(1.08)' }
    }
  },

  root: {
    position: 'relative',
    display: 'inline-grid',
    placeItems: 'center',
    width: 40,
    height: 40,
    borderRadius: 10,
    color: '#1d2433',
    cursor: 'pointer',
    transition: 'background 0.15s, color 0.15s',
    textDecoration: 'none',
    '&:hover': { background: '#eef1f6', color: '#0f172a' },
    '&:focus':  { outline: 'none' },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: -3, right: -3, bottom: -3, left: -3,
      borderRadius: 13,
      border: '2px solid #1fae5a',
      opacity: 0,
      pointerEvents: 'none',
      animation: 'helpCenterPulse 3s ease-in-out infinite'
    }
  },

  icon: {
    width: 22,
    height: 22,
    stroke: 'currentColor',
    fill: 'none',
    strokeWidth: 2
  }
});

const HelpCenter = ({ classes, modal, helpCenterlink }) => {
  if (modal) {
    return (
      <div>
        <a target="_blank" rel="noopener noreferrer" href={helpCenterlink}>
          <span data-tip data-for="help_center" className="lnr lnr-question-circle help_center__icon" />
        </a>
        <ReactTooltip id="help_center" place="bottom" effect="solid" type="light" className="help_center__tooltip-modal">
          <p>Ir al centro de ayuda</p>
        </ReactTooltip>
      </div>
    );
  }

  return (
    <React.Fragment>
      <a
        className={classes.root}
        href={helpCenterlink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Ir al centro de ayuda"
        data-tip
        data-for="help_center"
      >
        <svg className={classes.icon} viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="9.5" />
          <path d="M9.5 9a2.5 2.5 0 1 1 3.6 2.2c-.8.4-1.1.9-1.1 1.8M12 17h.01" />
        </svg>
      </a>
      <ReactTooltip id="help_center" place="bottom" effect="solid" type="light" className="help_center__tooltip-topbar">
        <p>Ir al centro de ayuda</p>
      </ReactTooltip>
    </React.Fragment>
  );
};

HelpCenter.propTypes = {
  classes: PropTypes.object.isRequired,
  modal: PropTypes.any,
  helpCenterlink: PropTypes.string
};

export default withStyles(styles)(HelpCenter);



// WEBPACK FOOTER //
// ./src/components/HelpCenter.js